import { Component, OnInit } from '@angular/core';
import { IPackageBuider } from 'app/shared/Domains/packageBuilder';
import { AppServiceManager } from 'common/services/appServiceManager';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DatePipe } from '@angular/common';
import { Configuration } from 'config/config';
import { BreadcrumbService } from 'app/breadcrumb.service';
import { AuthService } from 'common/services/auth.service';
import { ExportDataComponent } from 'app/members/components/export-data/export-data.component';
import { IUser } from 'app/shared/Domains/IUser';
import { LanguageService } from 'app/LanguageService/Language.Service';
@Component({
  selector: 'app-package-builders',
  templateUrl: './package-builders.component.html',
  styleUrls: ['./package-builders.component.css']
})
export class PackageBuildersComponent implements OnInit {
  packages: IPackageBuider[] = [];
  package: IPackageBuider;
  sourcePackages: IPackageBuider[];
  loading: boolean;
  dialogVisibility: boolean;
  options: any[];
  first: number = 0;
  months: any[];
  years: any[];
  user: IUser;
  tabIndex: number;
  role: any;

  constructor(private LanguageService: LanguageService, private route: ActivatedRoute, private router: Router, private confirmationService: ConfirmationService, private datePipe: DatePipe, public config: Configuration, private messageService: MessageService, private breadcrumbService: BreadcrumbService, private appServiceManager: AppServiceManager, private exportDataComponent: ExportDataComponent) {
    this.breadcrumbService.setItems([
      { label: 'All Packages' },
    ]);
  }
  setLabel(label) {
    return this.LanguageService.GetCurrentLanguage("PackageBuildersComponent", label);
  }
  ngOnInit() {
    this.loading = true;
    this.InitObjects();
    this.user = AuthService.getLoggedInUser();
    this.role = AuthService.getLoggedInRole();
    this.getPackageBuilders();
  }

  InitObjects() {
    this.package = new IPackageBuider();
    this.user = new IUser();
  }

  getPackageBuilders() {
    this.packages = [];
    this.sourcePackages = [];
    this.loading = true;
    this.appServiceManager.get('packagesBuilder/company/' + this.user.company + '/branch/' + this.user.branch).subscribe((res: IPackageBuider[]) => {
      if (res.length > 0) {
        this.packages = res.sort((a, b) => { return <any>new Date(a.sn) - <any>new Date(b.sn) });
        this.sourcePackages = res.sort((a, b) => { return <any>new Date(a.sn) - <any>new Date(b.sn) });
        this.loading = false;
      } else {
        this.loading = false;
        this.messageService.clear();
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: "No Record Found" });
      }

    },
      (error) => {
        this.loading = false;
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
  }

  searchLocal(value) {
    let matchedPackage = [];
    if (value !== null && value !== undefined && value.toString().length > 0) {
      if (value == "") {
        this.packages = Object.assign([], this.sourcePackages);
      }
      if (!value) {
        this.packages = Object.assign([], this.sourcePackages);
      }
      if (value != "") {
        matchedPackage = Object.assign([], this.sourcePackages).filter(
          pack => pack.packageName ? pack.packageName.toLowerCase().indexOf(value.toLowerCase()) > -1 : null);
        const distinct = (value, index, self) => {
          return self.indexOf(value) === index;
        }
        // const source = matchedPackage.concat(matchedPackage);
        this.packages = matchedPackage.filter(distinct);

        if (this.packages.length === 0) {
          this.packages = [];
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
        } else {

          this.packages = [...this.packages];
        }
      }
    } else {
      this.packages = Object.assign([], this.sourcePackages);
      this.packages = [...this.packages];
    }
  }


  deletePackage(_package: IPackageBuider) {
    this.confirmationService.confirm({
      message: "Are you sure you want to Delete the Package ?",
      accept: () => {
        this.loading = true;
        _package.isDelete = true;
        _package.scope = 'Package';
        _package.initiatedFrom = 'Package Builders';
        _package.type = 'Delete Package';
        _package.activityBy = this.user.name;
        this.appServiceManager.put('packagesBuilder/deletePackage', _package).subscribe((res: any) => {
          if (res.status === true) {
            this.messageService.clear();
            this.loading = false;
            this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Successfully Deleted' });
          }
          this.getPackageBuilders();
          this.loading = false;
          this.sourcePackages = [...this.sourcePackages]
        },
          (error) => {
            this.loading = false;
            this.messageService.clear();
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
          });
      }
    });
  }

  ExportData(packages, name) {
    this.confirmationService.confirm({
      message: "Are you sure you want to Export ?",
      accept: () => {
        const transformedData = packages.map(item => ({
          S_N: item?.sn,
          Package_Name: item?.packageName,
          Package_Type: item?.packageType,
          No_Of_Months: item?.noOfMonths,
          No_Of_Member: item?.noOfMembers,
          Package_Fee: parseFloat(item?.packageFee).toLocaleString('en-US', {maximumFractionDigits:0}),
          Status: item?.isDelete ? "Inactive" : "Active",
          Registration_Fee: parseFloat(item?.registerationFee).toLocaleString('en-US', {maximumFractionDigits:0}),
        }));


        const totalRecords = packages.length;


        //transformedData.push(summaryObject);
        this.exportDataComponent.ExportDataVisitors(transformedData, name);
      }
    });
    // calling export comp
  }

  handleTabChange(e) {
    var index = e.index;
    if (index == 0) {
      this.tabIndex = 0;
      // this.clearFulfilled();
    }
    if (index == 1) {
      this.tabIndex = 1;
      // this.clearUnfulfilled();
    }
  }

  viewPackageBuilder(packageBuilder: IPackageBuider) {
    this.router.navigateByUrl('package-Builders/package-Builder/' + packageBuilder._id)
  }

}
